import { Component, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { NzEmptyModule } from 'ng-zorro-antd/empty';
import { AccountProfileCard } from '../../../components/account/account-profile-card/account-profile-card';
import { UpdateAccountProfileDialog } from '../../../components/account/update-account-profile-dialog/update-account-profile-dialog';
import { UpdateUserShippingAddressDialog } from '../../../components/account/update-user-shipping-address-dialog/update-user-shipping-address-dialog';
import { UserShippingAddressListItem } from '../../../components/account/user-shipping-address-list-item/user-shipping-address-list-item';
import { UserShippingAddress } from '../../../models/shopping';
import { AccountApiService } from '../../../services/apis/account-api.service';
import { TitleService } from '../../../services/title.service';

@Component({
  selector: 'app-account-profile-page',
  imports: [
    AccountProfileCard,
    MatIconModule,
    MatButtonModule,
    MatDialogModule,
    NzEmptyModule,
    MatProgressSpinnerModule,
    UserShippingAddressListItem,
  ],
  templateUrl: './account-profile-page.html',
  styleUrl: './account-profile-page.scss',
})
export class AccountProfilePage implements OnInit {
  constructor(
    private titleService: TitleService,
    private dialog: MatDialog,
    private accountApi: AccountApiService
  ) {
    this.titleService.setTitle('Account Profile');
  }

  ngOnInit(): void {
    this.findUserShippingAddresses();
  }

  editProfile() {
    this.dialog.open(UpdateAccountProfileDialog, {
      width: '640px',
    });
  }

  editAddress(addr?: UserShippingAddress) {
    this.dialog
      .open(UpdateUserShippingAddressDialog, {
        width: '640px',
        data: addr,
      })
      .afterClosed()
      .subscribe((r) => {
        if (r) {
          this.findUserShippingAddresses();
        }
      });
  }

  loading: boolean = false;
  addresses: UserShippingAddress[] = [];
  async findUserShippingAddresses() {
    try {
      this.loading = true;
      this.addresses = await this.accountApi.findUserShippingAddresses();
    } catch (error) {
    } finally {
      this.loading = false;
    }
  }
}
